'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/twilsock/node_modules/core-js/internals/is-pure.js
// module id = 351
// module chunks = 25